<template>
  <router-view/>
</template>

<script>
  const App = {
    name: 'App',
    created() {
      if(window.screen.width >= 768){
        this.screenRatio(100, 1.3);
      }else{
        this.screenRatio();
      }
    },
    mounted() {
     
    },
    methods: {
      /* 获取屏幕dpr */
      dprRatio () {
        const ua = navigator.userAgent;
        const matches = ua.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i);
        const UCversion = ua.match(/U3\/((\d+|\.){5,})/i);
        const isHCHd = UCversion && parseInt(UCversion[i].split(',').join(''), 10) >= 80;
        const isIos = navigator.appVersion.match(/(iphone|ipad|ipod)/gi);
        var dpr = window.devicePixelRatio || 1;
        if (!isIos && !(matches && matches[1] > 534) && !isHCHd) {
          /*非ios，非安卓4.3以上，非UC内核，就不执行高清，dpr设为1*/
          dpr = 1;
        }
        return dpr;
      },
      /* 初始化屏幕比例 */
      screenRatio (baseFontSize, fontscale) {
        var ratio = this.dprRatio();
        localStorage.setItem('xianheSystemRatio', ratio);
        console.log(ratio, 'dpr');
        var scale = document.createElement('meta');
        var scaleRatio = 1 / ratio;
        scale.name = 'viewport';
        scale.content = 'width=device-width,' + 'initial-scale=' + scaleRatio +
          ', maximum-scale=' + scaleRatio + ', minimum-scale=' + scaleRatio +
          ', user-scalable=no';
        var s = document.getElementsByTagName('title')[0];
        s.parentNode.insertBefore(scale, s);
        var _baseFontSize = baseFontSize || 100;
        var _fontscale = fontscale || 1;
        document.documentElement.style.fontSize = _baseFontSize / 2 * ratio * _fontscale + 'px';
      },
    }
  }
  export default App
</script>

<style lang="less">
 html{
    height: 100%;
  }
  body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-y: hidden;
  }
  #app {
    height: 100%;
    width: 100%;
    overflow: auto;
  }
  a {
    text-decoration: none;
    color: #000;
  }
  .a-style{
      padding: 0px 30px;
    }
  .el-dialog .el-dialog__body{
    padding-bottom: 0px !important;
  }
  .el-dialog .el-dialog__footer{
    padding: 10px 20px !important;
  }
  // 跑马灯
  .el-carousel__item:nth-child(2n) {
    background-color: #409EFF;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #67C23A;
  }
  /*header*/
  .el-dropdown-menu__item{
      width: 120px !important;
    }
  .el-tag{
    margin: 5px;
  }
  /*menu*/
  /*.el-menu-item {*/
    /*padding-bottom: 8px;*/
    /*height: 50px;*/
    /*line-height: 50px;*/
  /*}*/
  .el-submenu .el-menu-item{
    min-width: 146px !important;
    padding-left: 50px !important;
  }

  .el-menu-item > a{
    display: block;
    color: #ccc;
  }
  .el-menu .is-active{
    outline: 0;
    background-color: rgb(67, 74, 80) !important;
  }
  .el-menu .is-active a{
    color: #fff !important;
  }
  .menu .is-active:before{
    position: absolute;
    bottom: 0px;
    left: 0;
    display: block;
    width: 4px;
    height: 56px;
    background-color: #3a79ff;
    transition: all .3s cubic-bezier(.645,.045,.355,1);
    content: "";
  }
  .menu .is-active:after{
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    border-right: 3px solid #3a79ff;
    transform: scaleY(.0001);
    opacity: 0;
    transition: transform .15s cubic-bezier(.215,.61,.355,1),opacity .15s cubic-bezier(.215,.61,.355,1);
  }
  .el-submenu .is-active:before {
    position: absolute;
    bottom: 0px;
    left: 0;
    display: block;
    width: 4px;
    height: 50px;
    background-color: #3a79ff;
    transition: all .3s cubic-bezier(.645,.045,.355,1);
    content: "";
  }
  .el-submenu .is-active:after{
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    border-right: 3px solid #3a79ff;
    transform: scaleY(.0001);
    opacity: 0;
    transition: transform .15s cubic-bezier(.215,.61,.355,1),opacity .15s cubic-bezier(.215,.61,.355,1);
  }
  /*重写弹窗样式*/
  .el-dialog {
    .el-dialog__header{
      padding: 9px 20px;
      border-bottom: 2px solid #3a79ff;
      text-align: left;
      line-height: 0;
    }
    .el-dialog__body{
      padding: 20px;
    }
    .el-dialog__footer{
      padding: 0 20px 20px;
      border-top: 0;
    }
    .el-dialog__headerbtn{
      top: 14px;
    }
  }
  /*滚动条*/
  *::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  *::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  *::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #777;
  }
  /*输入框*/
  *::placeholder {
    font-size: 12px;
  }
  // iconfont
  .icon {
    width: 1em;
    height: 1em;
    overflow: hidden;
  }
  .icon-middle {
    width: 2em;
    height: 2em;
    overflow: hidden;
  }
  // 视频
  .video-js {
    width: 100% !important;
  }
  // 分页
  .pagenation-box {
    .el-pagination__total, .el-pager li {
      font-size: 0.24rem !important;
    }
    .el-pager li {
      padding: 0 0.1rem !important;
      margin: 0 0.1rem !important;
    }
    button {
      margin: 0 0.2rem !important;
    }
  }
</style>
